//班组找活相关接口
import request from '@/http'
export const apiTeamSearchJob = {
  GetTeamsearchjobList: (data) => request.post(`/findJob/findList`, data), // 班组找活列表
  GetTeamsearchjobDetail: (no) => request.get(`/findJob/detail?no=${no}`),//班组找活详情
  GetTeamsearchjobRecommend: (data) => request.post(`/findJob/recommendList`, data), // 班组找活推荐列表
}